// SPDX-License-Identifier: AGPL-3.0-or-later
export const ExternalUrls = {
	SERVICE_STATUS: 'https://fluxerstatus.com',
	BLUESKY: 'https://bsky.app/profile/fluxer.app',
} as const;
